import ny1stScience from "./ny1stScienceQuizContent";
import ny1stSocialStudies from "./ny1stSocialStudiesQuizContent";
import ny1stMath from "./ny1stMathQuizContent";
import ny1stOther from "./ny1stOtherQuizContent";

// 2nd Grade
import ny2ndScience from "./ny2ndScienceQuizContent";
import ny2ndSocialStudies from "./ny2ndSocialStudiesQuizContent";
import ny2ndMath from "./ny2ndMathQuizContent";
import ny2ndOther from "./ny2ndOtherQuizContent";

// 3rd Grade
import ny3rdScience from "./ny3rdScienceQuizContent";
import ny3rdSocialStudies from "./ny3rdSocialStudiesQuizContent";
import ny3rdMath from "./ny3rdMathQuizContent";
import ny3rdOther from "./ny3rdOtherQuizContent";

// 4th Grade
import ny4thScience from "./ny4thScienceQuizContent";
import ny4thSocialStudies from "./ny4thSocialStudiesQuizContent";
import ny4thMath from "./ny4thMathQuizContent";
import ny4thOther from "./ny4thOtherQuizContent";

// 5th Grade
import ny5thScience from "./ny5thScienceQuizContent";
import ny5thSocialStudies from "./ny5thSocialStudiesQuizContent";
import ny5thMath from "./ny5thMathQuizContent";
import ny5thOther from "./ny5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const nytopicsMapBySubject = {
  // 1st Grade
ny_1st_science: ny1stScience,
ny_1st_socialstudies: ny1stSocialStudies,
ny_1st_math: ny1stMath,
ny_1st_other: ny1stOther,

// 2nd Grade
ny_2nd_science: ny2ndScience,
ny_2nd_socialstudies: ny2ndSocialStudies,
ny_2nd_math: ny2ndMath,
ny_2nd_other: ny2ndOther,

// 3rd Grade
ny_3rd_science: ny3rdScience,
ny_3rd_socialstudies: ny3rdSocialStudies,
ny_3rd_math: ny3rdMath,
ny_3rd_other: ny3rdOther,

// 4th Grade
ny_4th_science: ny4thScience,
ny_4th_socialstudies: ny4thSocialStudies,
ny_4th_math: ny4thMath,
ny_4th_other: ny4thOther,

// 5th Grade
ny_5th_science: ny5thScience,
ny_5th_socialstudies: ny5thSocialStudies,
ny_5th_math: ny5thMath,
ny_5th_other: ny5thOther,
  // ...add the rest
};
